import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-time-length-label',
  templateUrl: './time-length-label.component.html',
  styleUrls: ['./time-length-label.component.css']
})
export class TimeLengthLabelComponent implements OnInit {

  @Input()
  minutes: number;

  constructor() { }

  ngOnInit() {
  }

  get time(): [number, string] {
    if (this.minutes < 60) {
      return [this.minutes, 'Minute(s)'];
    }

    const hours = this.minutes / 60;
    if (hours < 24) {
      return [hours, 'Hour(s)'];
    }

    const days = hours / 24;
    if (days < 365) {
      return [days, 'Day(s)'];
    }

    const years = days / 365;
    return [years, 'Year(s)'];
  }

}
